import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'
import type {MilestoneRowMetadata$key} from './__generated__/MilestoneRowMetadata.graphql'
import styles from './RepositoryMilestone.module.css'
import {Link, ProgressBar} from '@primer/react'
import {MilestoneRowMenu} from './MilestoneRowMenu'

type MilestoneRowMetadataProps = {
  milestone: MilestoneRowMetadata$key
}

export function MilestoneRowMetadata({milestone}: MilestoneRowMetadataProps) {
  const data = useFragment(
    graphql`
      fragment MilestoneRowMetadata on Milestone {
        ...MilestoneRowMenu
        progressPercentage
        openIssueCount
        closedIssueCount
        title
      }
    `,
    milestone,
  )

  return (
    <div className={styles.listProgressSection}>
      <div className={styles.progress}>
        <ProgressBar
          progress={Math.floor(data.progressPercentage)}
          aria-hidden="true"
          data-testid="milestone-metadata-progress-bar"
          barSize="small"
          className={styles.progressBar}
        />
        <div className={styles.listMetadata}>
          <span>
            <span className={styles.progressPercentage}>{Math.floor(data.progressPercentage)}%</span> complete
          </span>
          <Link
            className={styles.link}
            href={`issues?q=${encodeURIComponent(`is:open milestone:"${data.title ?? ''}"`)}`}
          >
            <span className={styles.progressPercentage}>{data.openIssueCount}</span> open
          </Link>
          <Link
            className={styles.link}
            href={`issues?q=${encodeURIComponent(`is:closed milestone:"${data.title ?? ''}"`)}`}
          >
            <span className={styles.progressPercentage}>{data.closedIssueCount}</span> closed
          </Link>
        </div>
      </div>
      <MilestoneRowMenu milestone={data} />
    </div>
  )
}

try{ MilestoneRowMetadata.displayName ||= 'MilestoneRowMetadata' } catch {}